import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment-jalaali';
import 'react-datepicker/dist/react-datepicker.css';
import './rangepicker.scss';
import { toShamsi, toShamsiDate } from 'utils/scripts/date';



interface Props {
    endDate: any,
    startDate: any
    setStartDate: any,
    setEndDate: any
}

const persianMonths = [
    'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور',
    'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'
];

export const DateTimeRangePicker: React.FC<Props> = ({ setEndDate, setStartDate, startDate, endDate }) => {

    const handleStartDateChange = (date: Date | null) => {
        if (date) {
            const jalaliDate = moment(date).locale('fa').format('yyyy-MM-DD');

            if (jalaliDate < endDate) {
                console.log('start date selected', date)

                console.log('start date selected jalalo', jalaliDate)
                console.log('start date selected jalalo', toShamsiDate(jalaliDate))
                // Convert to Jalali format
                setStartDate(jalaliDate);
            }
        } else {
            setStartDate(null);
        }
    };

    const handleEndDateChange = (date: Date | null) => {
        if (date) {

            const jalaliDate = moment(date).locale('fa').format('yyyy-MM-DD');

            if (jalaliDate > startDate) {
                console.log('end date selected jalalo', jalaliDate)
                console.log('end date selected jalalo', toShamsiDate(jalaliDate))
                // Convert to Jalali format
                setEndDate(jalaliDate);
                // Convert to Jalali format
            }

        } else {
            setEndDate(null);
        }
    };

    // Custom header to render Persian month names
    const renderCustomHeader = ({
        date,
        changeYear,
        changeMonth,
    }: {
        date: Date;
        changeYear: (year: number) => void;
        changeMonth: (month: number) => void;
    }) => {

        const monthIndex = moment(date).month(); // Get current month index (0-11)
        const year = moment(date).locale('fa').toString().split(' ')[3]; // Get Persian year

        return (
            <div style={{ margin: '10px' }}>
                <button onClick={() => changeYear(moment(date).locale('fa').year() - 1)}>«</button>
                <select
                    value={monthIndex}
                    onChange={(e) => changeMonth(Number(e.target.value))}
                >
                    {persianMonths.map((month, index) => (
                        <option key={index} value={index}>
                            {month}
                        </option>
                    ))}
                </select>
                <span>{year}</span>
                <button onClick={() => changeYear(moment(date).locale('fa').year() + 1)}>»</button>
            </div>
        );
    };

    return (
        <div className='range-datetime-picker'>
            <div>
                <label>تاریخ شروع:</label>
                <DatePicker
                    selected={startDate ? new Date(startDate) : null}
                    onChange={handleStartDateChange}
                    dateFormat="yyyy-MM-dd" // Use a valid format for the DatePicker
                    placeholderText="از تاریخ"
                    isClearable
                    todayButton
                    showYearPicker={false}
                    customInput={<input readOnly />}
                    onKeyDown={(e) => e.preventDefault()} // Prevent keyboard input
                    locale={'fa'}
                    renderCustomHeader={renderCustomHeader}

                />
            </div>
            <div>
                <label>تاریخ پایان:</label>
                <DatePicker
                    selected={endDate ? new Date(endDate) : null}
                    onChange={handleEndDateChange}
                    dateFormat="yyyy-MM-dd" // Use a valid format for the DatePicker
                    placeholderText="تا تاریخ"
                    isClearable
                    locale={'fa'}
                    customInput={<input readOnly />}
                    onKeyDown={(e) => e.preventDefault()} // Prevent keyboard input                    readOnly
                    showYearPicker={false}
                    todayButton
                    renderCustomHeader={renderCustomHeader}

                />
            </div>
        </div>
    );
};